<div class="chat-history-page">

  <!-- Main Chat Content -->
  <div class="chat-content">

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-state">
      <div class="loading-spinner"></div>
      <p>Loading conversation...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !isLoading" class="error-state">
      <p>{{ error }}</p>
    </div>

    <!-- Messages -->
    <div *ngIf="!isLoading && !error" class="messages-container">

      <!-- Dynamic Messages -->
      <div *ngFor="let message of messages; let i = index; trackBy: trackByMessage" 
           class="message" 
           #messageItem
           [attr.data-author]="message.author"
           [ngClass]="{'user-message': message.author === 'client', 'bot-message': message.author === 'bot'}">
        
        <div *ngIf="message.author === 'client'" class="message-bubble">
          <p>{{ message.message.content.text || '' }}</p>
        </div>
        
        <div *ngIf="message.author === 'bot'" class="message-content">
          <p class="bot-response" [innerHTML]="message.displayText | formatMessage"></p>
        </div>
        
        <div class="message-time">
          {{ formatMessageTime(message.created) }}
        </div>
      </div>

      <!-- Auto-scroll anchor -->
      <div class="messages-end" #messagesEnd aria-hidden="true"></div>

      <!-- Bot typing bubble while waiting for first reply -->
      <div *ngIf="isWaitingForBot" class="message bot-message typing-bubble-row">
        <div class="message-content">
          <div class="typing-bubble" aria-live="polite" aria-label="Lilo is typing">
            <span></span><span></span><span></span>
          </div>
        </div>
      </div>
    </div>

    <!-- Follow-up Input -->
    <div class="follow-up-section">
      <div class="follow-up-card">
        <div class="follow-up-input-wrapper">
          <textarea
            class="follow-up-input"
            placeholder="Ask follow up"
            [(ngModel)]="followUpText"
            (keyup.enter)="sendFollowUp()"
            [disabled]="isSending"
            rows="1"
          ></textarea>
        </div>
        
        <button 
          class="send-btn" 
          type="button" 
          (click)="sendFollowUp()"
          [disabled]="isSending || !followUpText.trim()"
        >
          <img src="assets/chat/arrow-up-right.svg" alt="Send" />
        </button>
      </div>
    </div>

    <!-- Footer -->
    <div class="chat-footer">
      <p>
        Lilo is in beta and may make mistakes. Report issues or join our slack community for quick help.
      </p>
    </div>
  </div>
</div>
